import { createActionConst } from '../../../../utils/action.utils';

const BOARD_NAMESPACE = 'BOARD';

export const STORE_BOARD = createActionConst(BOARD_NAMESPACE, 'STORE_BOARD');
export const CLEAR_BOARD = createActionConst(BOARD_NAMESPACE, 'CLEAR_BOARD');
